import * as React from "react";

import "./confirmation-modal.scss";

import {cs} from "@Common/react/chain-services";

import {ModalService3} from "../../../../modal-service-3/modal-service-3";

export const ConfirmationModal = ({confirmRemoval, next: rootNext}) => cs(
    ["modal", (_, next) => ModalService3({
        xToClose: false,
        xdQaName: "Confirmation Modal",
        next,
        rootNext,
    })],
    ({modal}) => (
        <div className="confirmation-modal-14o">
            <div className="message">
                Are you sure you want to remove this account?
            </div>
            <div className="footer">
                <div className="line">
                    <button
                        className="cancel"
                        onClick={modal.close }
                        xd-qa-type="button"
                    >No</button>
                </div>
                <div className="line">
                    <button
                        className="proceed"
                        onClick={ () => { confirmRemoval(); modal.close(); } }
                        xd-qa-type="button"
                    >Yes</button>
                </div>
            </div>
        </div>
    )
);
